export const SetServices = (services) =>({
    type: 'SET_SERVICES',
    payload: services
})